import React from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import { isPartialHoliday } from '../../../../shared/utils/store/store';

import './store-holiday-message.scss';

export default function StoreHolidayMessage(props) {
  const { day } = props;

  const isSat =
    format(day?.formattedDate || '', 'dddd').toLowerCase() === 'saturday';

  const firstOpeningTime = '8:00 AM';
  const firstClosingTime = day?.closingTime
    ? day?.closingTime?.formattedHour
    : '';
  const reopeningTime = day?.openingTime ? day?.openingTime.formattedHour : '';
  const finalClosingTime = isSat ? '5:00 PM' : '6:00 PM';
  const holidayTimes = [];

  if (firstOpeningTime !== firstClosingTime) {
    holidayTimes.push({
      time: `8:00 AM - ${firstClosingTime}`,
      type: 'Open'
    });
  }

  if (firstClosingTime && reopeningTime) {
    holidayTimes.push({
      time: `${firstClosingTime} - ${reopeningTime}`,
      type: 'Closed'
    });
  }

  if (finalClosingTime !== reopeningTime) {
    holidayTimes.push({
      time: `${reopeningTime} - ${finalClosingTime}`,
      type: 'Open'
    });
  }

  return (
    <strong className="store-closed-message-body">
      {isPartialHoliday(day)
        ? holidayTimes.map((timeRange, idx) => (
            <span key={`tr-${idx}`} styleName="store-closed-holiday-time">
              {timeRange?.type}: {timeRange?.time}
            </span>
          ))
        : 'Store Closed'}
    </strong>
  );
}

StoreHolidayMessage.propTypes = {
  day: PropTypes.shape({
    closed: PropTypes.bool,
    closingTime: PropTypes.shape({
      formattedHour: PropTypes.string,
      hour: PropTypes.number,
      minute: PropTypes.number
    }),
    dayOfWeek: PropTypes.string,
    formattedDate: PropTypes.string,
    openingTime: PropTypes.shape({
      formattedHour: PropTypes.string,
      hour: PropTypes.number,
      minute: PropTypes.number
    })
  })
};
